/**
 * Заголовок по пути — для H1 в Topbar (роуты внутри AppLayout).
 * document.title каждая страница ставит сама через `useDocumentTitle`.
 */
export const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Дашборд',
  '/calls': 'Звонки',
  '/meetings': 'Встречи',
  '/clients': 'Клиенты',
  '/tasks': 'Задачи',
  '/processed': 'Обработанные',
  '/team': 'Команда',
  '/user-metrics': 'Метрики',
  '/communications': 'Все коммуникации',
  '/sandbox': 'Песочница',
  '/sandbox/plans': 'Песочница',
  '/sandbox/communications': 'Песочница',
  '/settings/workspace': 'Настройки воркспейса',
  '/admin/clients': 'Клиенты',
  '/admin/sources': 'Источники',
  '/admin/monitoring': 'Мониторинг',
  '/login': 'Вход',
  '/support': 'Поддержка',
  '/privacy-policy': 'Политика конфиденциальности',
  '/cookie-policy': 'Политика использования cookie',
};

/**
 * Вторая строка заголовка — «акциденция» из брендбука GMK: заголовок набирается
 * капсом в две строки, вторая — серым (GRAY MID2).
 */
export const PAGE_TITLE_ACCENTS: Record<string, string> = {
  '/dashboard': 'Отдела продаж',
  '/calls': 'И оценки разговоров',
  '/meetings': 'С клиентами',
  '/clients': 'И история контактов',
  '/tasks': 'Команды',
  '/processed': 'Звонки',
  '/team': 'И доступы',
  '/user-metrics': 'Работы с сервисом',
  '/communications': 'Приём и обработка',
  '/sandbox': 'Планы анализа',
  '/sandbox/plans': 'Планы анализа',
  '/sandbox/communications': 'Проверка коммуникаций',
  '/admin/clients': 'Платформы',
  '/admin/sources': 'Звонков',
  '/admin/monitoring': 'Обработки',
};
